import React, { useMemo } from "react";
import Status from "../../../../components/Status";
import FontAwesomeIcon from "../../../../components/Icon";
import "./index.scss";
import { useBranding } from "../../../../branding/BrandingContextProvider";
export const ServiceRequestStats = ({ data }) => {
  const closedPercentage = useMemo(() => {
    return Math.max(0, Math.min(
      Math.floor((data.closed / data.total) * 100),
      100
    ));
  }, [data.closed, data.total]);
  return (
    <div className="service_request_stats_container">
      <ServiceRequestStatCard title="Total" value={data.total} glyph="circle" />
      <ServiceRequestStatCard
        title="Active"
        value={data.active}
        glyph="tasks"
      />
      <ServiceRequestStatCard
        title="Closed"
        value={data.closed}
        glyph="check-circle"
      />
      <ServiceRequestStatCard
        title="Average Days to Resolution"
        value={data.averageDaysToResolution}
        glyph="calendar"
      />
      <ServiceRequestStatCard
        title="Closed Percentage"
        value={`${closedPercentage}%`}
        glyph="percentage"
      />
    </div>
  );
};

const ServiceRequestStatCard = ({ title, value, glyph }) => {
  const { branding, isBranded } = useBranding();
  return (
    <div className="card__item compact">
      <Status icon={<FontAwesomeIcon glyph={glyph} weight="solid" />} label={title} />
      <div
        className="card__count"
        style={{
          color: isBranded ? branding.colours.text.emphasis : undefined,
        }}
      >
        {value}
      </div>
    </div>
  );
};
